import React, { Component } from 'react';
import { Link } from 'react-router-dom';


export default class Privacy extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        return (
            <div className="content-container">
                <div className="content-wrapper content-wrapper--vertical-padding">
                    <div className="legal__title text-title">
                        Privacy Policy
                    </div>
                    <div className="legal__textbox text-color-grey">
                        Updated: 2025-5-15
                    </div>

                    <div className="legal__title text-subtitle">
                        1. Who We Are
                    </div>
                    <div className="legal__textbox">
                        Guidr (“we,” “us,” “our”) runs the online platform at guidr.net that connects travel creators with travelers.
                    </div>

                    <div className="legal__title text-subtitle">
                        2. Scope
                    </div>
                    <div className="legal__textbox">
                        This Policy applies to your use of our website, mobile apps, and related APIs (collectively, the “Services”).
                    </div>

                    <div className="legal__title text-subtitle">
                        3. Information We Collect
                    </div>
                    <div className="legal__textbox">
                        Account data (for example, name, email, password, profile picture) to create, manage, and authenticate your account.
                        <br />
                        Creator content (for example, itineraries, images, videos, metadata) to publish and share trip itineraries.
                        <br />
                        Transactional data (for example, payment information, purchase history) to process payments and manage transactions.
                        <br />
                        Usage data (for example, IP address, device type, browsing actions) to analyze how you use our Services and improve them.
                        <br />
                        Cookies and similar technologies (for example, first-party GA4 cookies) to monitor site performance and other metrics.
                    </div>

                    <div className="legal__title text-subtitle">
                        4. How We Use Your Information
                    </div>
                    <div className="legal__textbox">
                        Operate, maintain, and improve the Services.
                        <br />
                        Facilitate purchases and creator payouts.
                        <br />
                        Provide customer support and security monitoring.
                        <br />
                        Send transactional or marketing communications (you may opt out).
                        <br />
                        Comply with legal obligations and enforce our Terms of Service.
                    </div>

                    <div className="legal__title text-subtitle">
                        5. Legal Bases for EU/UK Users
                    </div>
                    <div className="legal__textbox">
                        We process personal data on one or more of the following bases: (a) performance of a contract; (b) legitimate interests (e.g., platform security, fraud prevention); (c) your consent (e.g., marketing emails, optional cookies); (d) compliance with legal obligations.
                    </div>

                    <div className="legal__title text-subtitle">
                        6. Sharing & Disclosure
                    </div>
                    <div className="legal__textbox">
                        We never sell personal data. We share it only:
                        <br />
                        Service Providers. Payment processors, cloud hosting (AWS), analytics vendors, support tools—bound by confidentiality.
                        <br />
                        Legal. When required by law or to protect rights, safety, or property.
                        <br />
                        Business Transfers. In connection with a merger, acquisition, or asset sale (with notice to you).
                    </div>

                    <div className="legal__title text-subtitle">
                        7. International Transfers
                    </div>
                    <div className="legal__textbox">
                        Primary storage is on AWS servers located in the United States. AWS maintains ISO 27001, SOC 2, and other certifications and supports region-to-region replication with encryption at rest and in transit.
                        We may transfer data to other jurisdictions where we or our processors operate; when we do, we rely on lawful transfer mechanisms such as standard contractual clauses or adequacy decisions.
                    </div>

                    <div className="legal__title text-subtitle">
                        8. Security
                    </div>
                    <div className="legal__textbox">
                        We use industry-standard safeguards, including:
                        <br />
                        Encryption in transit (TLS 1.2+).
                        <br />
                        Principle of least privilege for IAM roles.
                        <br />
                        Continuous monitoring, logging, and automated alerts.
                        <br />
                        No method of transmission or storage is 100 % secure; we cannot guarantee absolute security.
                    </div>

                    <div className="legal__title text-subtitle">
                        9. Data Retention
                    </div>
                    <div className="legal__textbox">
                        We retain personal data only as long as necessary for the purposes described in this Policy, to meet legal obligations, or to resolve disputes, after which we securely delete or anonymize it.
                    </div>

                    <div className="legal__title text-subtitle">
                        10. Your Rights
                    </div>
                    <div className="legal__textbox">
                        Depending on where you live, you may have the right to:
                        <br />
                        Access a copy of your data
                        <br />
                        Correct inaccurate data
                        <br />
                        Delete your data (“right to be forgotten”)
                        <br />
                        Port your data to another service
                        <br />
                        Object to or restrict certain processing
                        <br />
                        Opt out of “sale” or “sharing” (for CA residents)
                        <br />
                        To exercise any right, email info@guidr.net.
                    </div>

                    <div className="legal__title text-subtitle">
                        11. Children’s Privacy
                    </div>
                    <div className="legal__textbox">
                        Guidr is not directed to children under 13, and we do not knowingly collect their personal information. If we learn we have done so, we will delete it as required by COPPA. 
                    </div>

                    <div className="legal__title text-subtitle">
                        12. Cookies & Similar Technologies
                    </div>
                    <div className="legal__textbox">
                        We use first-party cookies (e.g., Google Analytics 4) to understand usage patterns and improve performance. You can refuse or disable cookies via your browser settings; the site may still function but certain features could be limited. 
                    </div>

                    <div className="legal__title text-subtitle">
                        13. Third-Party Links
                    </div>
                    <div className="legal__textbox">
                        Itineraries may link to external booking sites or resources. We are not responsible for the privacy practices of those third parties.
                    </div>

                    <div className="legal__title text-subtitle">
                        14. Changes to This Policy
                    </div>
                    <div className="legal__textbox">
                        We may update this Policy periodically. Material changes will be posted on this page with an updated “Last Updated” date. Continued use of the Services after changes constitutes acceptance.
                    </div>

                    <div className="legal__title text-subtitle">
                        15. Contact Us
                    </div>
                    <div className="legal__textbox">
                        For privacy questions or complaints, please email info@guidr.net.
                    </div>

                </div>
            </div>
        )
    }
}
